var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 10.375H1.125V0.625C1.125 0.55625 1.06875 0.5 1 0.5H0.125C0.05625 0.5 0 0.55625 0 0.625V11.375C0 11.4438 0.05625 11.5 0.125 11.5H11.875C11.9438 11.5 12 11.4438 12 11.375V10.5C12 10.4313 11.9438 10.375 11.875 10.375ZM2.77813 7.96406C2.82656 8.0125 2.90469 8.0125 2.95469 7.96406L5.11563 5.81406L7.10938 7.82031C7.15781 7.86875 7.2375 7.86875 7.28594 7.82031L11.5891 3.51875C11.6375 3.47031 11.6375 3.39063 11.5891 3.34219L10.9703 2.72344C10.9468 2.70017 10.9151 2.68712 10.882 2.68712C10.849 2.68712 10.8172 2.70017 10.7938 2.72344L7.2 6.31563L5.20938 4.3125C5.18588 4.28924 5.15416 4.27619 5.1211 4.27619C5.08803 4.27619 5.05631 4.28924 5.03281 4.3125L2.16094 7.16719C2.13768 7.19068 2.12463 7.22241 2.12463 7.25547C2.12463 7.28853 2.13768 7.32026 2.16094 7.34375L2.77813 7.96406Z",
    fill: "current",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.7403a6c2befff86fd73ee070171b37e0.svg";
export { ForwardRef as ReactComponent };